'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

class Gamification {
  leaderboard(params) {
    return transport.transport.request("gamification/leaderboard", params);
  }
  achievement(params) {
    return transport.transport.request("gamification/achievement", params);
  }
  collectGameClickEvents(params) {
    return transport.transport.request("gamificationV2/pushGameClickEvents", params);
  }
}

exports.Gamification = Gamification;
